import TimetablePage from "./TimetablePage";

export default TimetablePage;
